/**
 * Отступ и сортировка списков KLS по kls_rubrika (ltree), как в формах объекта / useKlsOptions.
 */

import type { Kls, KlsSearchResult, KlsWithQual } from "@/types/api-v2";

export type KlsComboboxRow = {
  kls_id: number;
  kls_namef: string;
  kls_names?: string | null;
  kls_code: string;
  /** Путь рубрикатора; пустая строка — без иерархии в ответе поиска (старый API). */
  kls_rubrika: string;
};

/** Уровень вложенности для отступа (корень = 0), по числу сегментов в rubrika. */
export function klsRubrikaIndentLevel(rubrika?: string | null): number {
  if (rubrika == null || !String(rubrika).trim()) return 0;
  const depth = String(rubrika).split(".").filter(Boolean).length;
  return Math.max(depth - 1, 0);
}

/** Левый отступ строки в выпадающем списке (px). */
export function klsHierarchyRowPaddingLeftPx(indentLevel: number): number {
  return 8 + indentLevel * 16;
}

export function toKlsComboboxRows(
  list: (KlsWithQual | KlsSearchResult)[]
): KlsComboboxRow[] {
  return list.map((k) => {
    const rubrika =
      typeof (k as KlsSearchResult).kls_rubrika === "string"
        ? (k as KlsSearchResult).kls_rubrika!
        : typeof (k as Kls).kls_rubrika === "string"
          ? (k as Kls).kls_rubrika
          : "";
    return {
      kls_id: k.kls_id,
      kls_namef: k.kls_namef,
      kls_names: k.kls_names,
      kls_code: k.kls_code,
      kls_rubrika: rubrika,
    };
  });
}

export function sortKlsComboboxRowsByRubrika(rows: KlsComboboxRow[]): KlsComboboxRow[] {
  return [...rows].sort((a, b) =>
    a.kls_rubrika.localeCompare(b.kls_rubrika, undefined, { numeric: true })
  );
}
